export default __webpack_public_path__ + "card-placeholder.svg?b7796b744a9baef50b45bfde082259e8";